import {IMAGE_POPUP_OPEN_DATA_ATTRIBUTE} from './constants';

export const checkIfImagePopupVisible = () => {
  return window.document.body.hasAttribute(IMAGE_POPUP_OPEN_DATA_ATTRIBUTE);
};
